module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/_cache/steps-13.vue");


//////////////////
// WEBPACK FOOTER
// ./docs/examples-docs/steps.md
// module id = 346
// module chunks = 0